import React from "react";

const Projects = () => (
  <section className="my-projects">
    <div className="container">
      <h3>Some Of My Projects</h3>

      <div className="cards__grid">
        <a
          href="https://react-rmdb-movielist.netlify.app/"
          target="_blank"
          className="cards__item"
        >
          <div
            className="cards__image"
            style={{ backgroundImage: `url('/images/project1.jpg')` }}
          ></div>
          <div className="cards__text">
            <div className="cards__title">React RMDB</div>
            <div className="cards__description">
              Developed using RMDB api with React. You can list populer movies
              and more information about them.
            </div>
          </div>
        </a>

        <a
          href="https://expesify-1c889.web.app/"
          target="_blank"
          className="cards__item"
        >
          <div
            className="cards__image"
            style={{ backgroundImage: `url('/images/project2.jpg')` }}
          ></div>
          <div className="cards__text">
            <div className="cards__title">Expensify</div>
            <div className="cards__description">
              Developed a web application using Firebase as database with React
              and Redux.
            </div>
          </div>
        </a>

        <a
          href="https://enes-hangman.netlify.app/"
          target="_blank"
          className="cards__item"
        >
          <div
            className="cards__image"
            style={{ backgroundImage: `url('/images/project3.jpg')` }}
          ></div>
          <div className="cards__text">
            <div className="cards__title">Hangman</div>
            <div className="cards__description">
              Created a hangman game using HTML/CSS/Javascript. You have 5
              guesses. If you want, you can reset the word.
            </div>
          </div>
        </a>

        <a
          href="https://enes-keeper-app.netlify.app/"
          target="_blank"
          className="cards__item"
        >
          <div
            className="cards__image"
            style={{ backgroundImage: `url('/images/project4.jpg')` }}
          ></div>
          <div className="cards__text">
            <div className="cards__title">Keeper App</div>
            <div className="cards__description">
              This project designed to take notes for anything you want. Coded
              with React and Material-UI.
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
);

export default Projects;
